<div class="main-content" style="padding-top: 60px;">
    <section class="pt-0">
        <div class=" container mb-2">
            <div class="row loadig-row-section">

                <div class="col load-content-section">

                    <div class="section content-title" data-aos="fade-up">
                        <!-- <span class="article-breadcrumb-sec" *ngIf="themeSettingsData.banner_heading"
                            title="{{themeSettingsData.banner_heading}}">
                            <span (click)="goToPage('')" class="breadcrumb-nav" role="navigation" aria-label="Breadcrumb">
                                <span class="nav-string nav-string-home"> {{themeSettingsData.banner_heading}}</span>
                                <fa-icon aria-hidden="true" class="angle-icon" [icon]="['fas', 'angle-right']">
                                </fa-icon>
                            </span>

                            <span>
                                {{contentData.page_heading}}
                            </span>
                        </span> -->
                        <nav class="article-breadcrumb-sec" *ngIf="themeSettingsData.banner_heading"
                            aria-label="Breadcrumb">
                            <ol class="breadcrumb-nav" style="list-style: none; display: flex; padding: 0; margin: 0;">
                                
                                <!-- First breadcrumb item -->
                                <li>
                                    <a (click)="goToPage('')" class="nav-string nav-string-home" role="button" tabindex="0" title="{{themeSettingsData.banner_heading}}">
                                        {{ themeSettingsData.banner_heading }}
                                    </a>
                                    <fa-icon aria-hidden="true" class="angle-icon" [icon]="['fas', 'angle-right']"
                                        style="margin: 0 8px;"></fa-icon>
                                </li>

                                <!-- Current page -->
                                <li aria-current="page" title="{{ contentData.page_heading }}" style="cursor: auto;">
                                    {{ contentData.page_heading }}
                                </li>

                            </ol>
                        </nav>
                        <div class="content-title d-flex" data-aos="fade-up">
                            <div class="col-12 content-head-align">
                                <!-- <div *ngIf="loaderContent heading" class="headContent-div"> -->
                                <h2 *ngIf="loaderContent "
                                    class="justify-content heading load-content content-loader mt-2"
                                    style="width: 50%;">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </h2>
                                <!-- </div> -->
                                <title *ngIf="!loaderContent" class=" justify-content heading load-content mt-2">
                                    {{contentData.page_heading}}</title>
                            </div>
                        </div>
                        <div class="content-section">
                            <div *ngIf="loaderContent">
                                <p tabindex="0" class="headingContent content-loader"></p>
                                <p tabindex="0" class="headingContent content-loader"></p>
                                <p tabindex="0" class="headingContent content-loader"></p>
                                <p tabindex="0" class="headingContent content-loader"></p>
                                <p tabindex="0" class="headingContent content-loader"></p>
                                <p tabindex="0" class="headingContent content-loader"></p>
                                <p tabindex="0" class="headingContent content-loader"></p>
                                <p tabindex="0" class="headingContent content-loader"></p>
                                <p tabindex="0" class="headingContent content-loader"></p>
                                <p tabindex="0" class="headingContent content-loader"></p>
                                <p tabindex="0" class="headingContent content-loader"></p>
                                <p tabindex="0" class="headingContent content-loader"></p>
                                <p tabindex="0" class="headingContent content-loader"></p>
                                <p tabindex="0" class="headingContent content-loader"></p>
                            </div>

                            <!-- <p #content *ngIf="loaderContent" ="0" class="headingContent content-loader">
                            </p>
                            <p #content *ngIf="loaderContent" tabindex="0" class="headingContent content-loader">
                            </p>
                            <p #content *ngIf="loaderContent" tabindex="0" class="headingContent content-loader">
                            </p> -->
                            <div *ngIf="!loaderContent" tabindex="0" class="load-content contente-div-section "
                                [innerHTML]="sanitizedContent" (click)="onContentClick($event)">
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-3 pl-3">
                            <h5> content outline</h5>
                            <div class="timeline" >
                                <div class="timeline-container primary" *ngFor="let content of contentOutline; let i = index">
                                    <div class="timeline-icon">
                                        <i class="far fa-grin-wink"></i>
                                        <div></div>
                                    </div>
                                    <div class="timeline-body">
                                        <p>{{content.title}}</p>
                                    </div>
                                </div>
                            </div>
                        </div> -->


                </div>
            </div>
        </div>
    </section>
    <!-- <button (click)="signIn()">Sign In</button> -->

</div>